import { ColumnConfig } from '../hooks/useTablePreferences';

export const taskRuleColumns: ColumnConfig[] = [
  {
    key: 'name',
    label: 'Name',
    defaultWidth: 220,
    minWidth: 160,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'taskType',
    label: 'Task Type',
    defaultWidth: 180,
    minWidth: 130,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'context',
    label: 'Context',
    defaultWidth: 130,
    minWidth: 100,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'area',
    label: 'Area',
    defaultWidth: 110,
    minWidth: 80,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'severity',
    label: 'Severity',
    defaultWidth: 120,
    minWidth: 90,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'dateField',
    label: 'Date Field',
    defaultWidth: 180,
    minWidth: 130,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'isActive',
    label: 'Active',
    defaultWidth: 90,
    minWidth: 70,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
];
